import React, {useState, useCallback} from 'react';
import { QuizOption } from '../../../types/cards';
import './SingleChoiceContent.css';
import {useUserChoicesStore} from "../../../store/userChoicesStore";
import {pushInfoToGoogleData} from "../../../utils/googleTag";
import {facebookEventFire} from "../../../utils/facebookEventFire";
interface RadioSelectorProps {
    options: QuizOption[];
    onSelect: (value: string) => void;
    selectedValues: string[];
    stepId: string | number;
    stepIndex: number;
    step: any;
    cardTitle: string;
}

export const SingleChoiceContent: React.FC<RadioSelectorProps> = ({ options, onSelect, selectedValues, stepId, stepIndex, cardTitle, step }) => {
   const { addChoice } =  useUserChoicesStore()
   const [isSelectionDisabled, setIsSelectionDisabled] = useState(false);
   const [immediateSelection, setImmediateSelection] = useState<string | null>(null);


    const handleSelect = useCallback((value: string) => {
        // Prevent multiple rapid clicks
        if (isSelectionDisabled) {
            return;
        }

        // Disable selection temporarily
        setIsSelectionDisabled(true);

        const selectedOption = options.find(opt => opt.value === value);
        if (selectedOption) {
            pushInfoToGoogleData({
                event: 'item_selected',
                data: {
                    stepId,
                    stepIndex,
                    cardTitle,
                    selected_options: selectedOption.value
                }
            })
            facebookEventFire('ItemSelected', {userData: {},
              customData: {stepId, stepIndex, cardTitle, selected_options: selectedOption.value}});
            // Check if stepContent has dataField equal to "goal"
            const stepContent = step.stepContent?.[0];
            const goalData = stepContent && 'dataField' in stepContent && stepContent.dataField === 'goal'
            const targetData = stepContent && 'dataField' in stepContent && stepContent.dataField === 'target'

            if(goalData){
                addChoice({
                    stepIndex: step.stepIndex,
                    content: {
                        stepTitle: step.title,
                        optionId: selectedOption.id,
                        optionValue: selectedOption.value,
                        goal: true,
                        emoji: selectedOption.emoji
                    }
                })
            }
            if(targetData){
                addChoice({
                    stepIndex: step.stepIndex,
                    content: {
                        stepTitle: step.title,
                        optionId: selectedOption.id,
                        optionValue: selectedOption.value,
                        target: true,
                        emoji: selectedOption.emoji
                    }
                })
            }

            addChoice({
                stepIndex: step.stepIndex,
                content: {
                    stepTitle: step.title,
                    optionId: selectedOption.id,
                    optionValue: selectedOption.value,
                }
            })
        }
        // console.log("Funnel state ", getFunnel())

        // Show selection immediately for visual feedback
        setImmediateSelection(value);

        // Navigate to next step after 300ms delay
        setTimeout(() => {
            onSelect(value);
        }, 300);

        // Re-enable selection after 500ms
        setTimeout(() => {
            setIsSelectionDisabled(false);
            setImmediateSelection(null);
        }, 500);
    }, [isSelectionDisabled, options, stepId, stepIndex, cardTitle, step, addChoice, onSelect]);

    return (
        <div className="radio-selector">
            {options.map((option) => (
                <button
                    key={option.id}
                    className={`radio-selector__option ${(selectedValues.includes(option.value) || immediateSelection === option.value) ? 'radio-selector__option--selected' : ''} ${isSelectionDisabled ? 'radio-selector__option--disabled' : ''}`}
                    onClick={() => handleSelect(option.value)}
                    disabled={isSelectionDisabled}
                >
                    <div className="radio-selector__text">
                        <span className="radio-selector__title">
                            <span className={"radio-selector__emoji"}>{option.emoji}</span>
                            <span>{option.title || option.text}</span>
                        </span>
                        {option.text && option.text !== option.title && (
                            <span className="radio-selector__description">{option.text}</span>
                        )}
                    </div>
                    <div className="radio-selector__radio">
                        {(selectedValues.includes(option.value) || immediateSelection === option.value) && (
                            <div className="radio-selector__radio-inner" />
                        )}
                    </div>
                </button>
            ))}
        </div>
    );
};
